import * as React from 'react';
import { AccordionItem } from '@grandvisionhq/common';
import { useFacetLabel } from '../../hooks/use-facet-label.js';
import { useSearchableRefinementList } from '../../hooks/use-searchable-refinement-list.js';
import { FacetSearchBox } from '../FacetSearchBox/FacetSearchBox.js';
import RefinementItem from '../RefinementItem/RefinementItem.js';

const FacetContainerMobile = ({ facet , onChange  })=>{
    const { sortedItems , refine , isFromSearch , setQuery  } = useSearchableRefinementList({
        facet
    });
    const label = useFacetLabel({
        facet
    });
    if (!sortedItems.length && !isFromSearch) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(AccordionItem, {
        id: facet.id,
        label: label,
        headingLevel: "h3",
        className: "facet-container-mobile"
    }, facet.searchable && /*#__PURE__*/ React.createElement(FacetSearchBox, {
        onSearch: setQuery,
        className: "facet-container-mobile__search"
    }), /*#__PURE__*/ React.createElement("fieldset", null, sortedItems.map((item)=>/*#__PURE__*/ React.createElement(RefinementItem, {
            key: item.label,
            item: item,
            facet: facet,
            onRefine: refine,
            onChange: onChange
        })
    )));
};

export { FacetContainerMobile };
//# sourceMappingURL=FacetContainerMobile.js.map
